<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <!-- Header -->
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('Company')}}</h6>
                                <h1 class="header-title">{{$t('Presets')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:modalName, model:presetDefaults})"
                                    class="btn btn-primary"
                                >{{$t('Add')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Card -->
                <div class="row">
                    <div class="col-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="service-draggable" v-for="(specialty, index) in specialties" :key="index">
                                    <div class="row align-items-center active">
                                        <div class="col-auto" v-if="specialty._id == specialtyId">
                                            <router-link :to="{name:'company.presets'}">
                                                <i class="fe fe-x"></i>
                                            </router-link>
                                        </div>
                                        <div class="col">
                                            <h4 class="card-title mb-1">
                                                <router-link
                                                    :to="{name:'company.presets', params:{specialtyId:specialty._id}}"
                                                >{{specialty.label}}</router-link>
                                            </h4>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="card" data-toggle="lists">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <!-- Search -->
                                        <div class="row align-items-center">
                                            <div class="col-auto pr-0">
                                                <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                                <span class="fe fe-search text-muted" v-else></span>
                                            </div>
                                            <div class="col">
                                                <input
                                                    type="search"
                                                    v-model="query"
                                                    class="form-control form-control-flush search no-glow"
                                                    :placeholder="$t('Search')"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- / .row -->
                            </div>

                            <simple-table
                                :data="presets"
                                :loading="arePresetsLoading"
                                :edit="edit"
                                :columns="columns"
                                :sort="sort"
                            ></simple-table>
                            <preset-form-modal :data="model" :errors="errors" :id="modalName"></preset-form-modal>
                        </div>
                    </div>
                </div>
                <div class="mt-3 text-center" v-if="totalRows > perPage">
                    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SimpleTable from '@/components/SimpleTable.vue'
import PresetFormModal from './PresetFormModal.vue'
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import debounce from 'lodash/debounce';

export default {
    props: ['specialtyId'],
    mixins: [modalMixins],
    components: {
        SimpleTable,
        PresetFormModal,

    },
    data() {
        return {
            presetDefaults: {
            },
            date: null,
            modalName: 'presetsFormModal',
            query: null,
            params: {},
            treatmentsQuery: [],
            currentPage: 1,
            perPage: 100,
            totalRows: 0,
            sort: 'createdAt',
            order: -1,
            dates: {},
            date_range: null,
            model: {},
            errors: {},
            columns: [
                {
                    label: 'Label',
                    name: 'label',
                },
                // {
                //     label: 'Specialty',
                //     field(row) {
                //         // let items = this.findSpecialtyInStore({ query: { _id: { $in: row.specialty } } })
                //         // return items;
                //     }
                // },

            ],

        };
    },
    computed: {
        ...mapGetters('specialty', { findSpecialtyInStore: 'find' }),
        ...mapState('presets', { arePresetsLoading: 'isFindPending' }),

        ...mapGetters('presets', {
            findItemsInStore: 'find'
        }),
        specialties() {
            return this.findSpecialtyInStore({query: {$sort: {createdAt: 1}}}).data;
        },
        presets() {
            let data = this.findItemsInStore(this.params).data;
            return data;
        },
    },
    watch: {
        query: debounce(function (newVal) {
            this.findItems();
        }, 400),
        currentPage: debounce(function (newVal) {
            this.findItems();
        }, 400),
        treatmentsQuery: debounce(function (newVal) {
            this.findItems();
        }, 400),
        specialtyId: debounce(function (newVal) {
            this.findItems();
        }, 400),


    },
    created() {
        this.findItems();


    },
    methods: {
        ...mapActions('presets', ['find']),

        findItems() {
            let params = {
                query: {
                    $limit: this.perPage,
                    $skip: (this.currentPage - 1) * this.perPage,
                    $sort: {
                        [this.sort]: this.order
                    }
                }
            }

            if (this.query) {
                // params.query.$search = this.query;
                params.query.$or = [
                    { label: { $regex: this.query, $options: "i" } },

                ];
            }

            if (this.specialtyId) {
                params.query.specialty = this.specialtyId;
            } else {
                delete params.query.specialty;
            }



            this.params = params;
            this.find(params).then(data => {
                this.totalRows = data.total;
            });
        },

        edit(item) {
            this.openModal({
                id: this.modalName,
                model: item
            })
        },
    }
}
</script>
